// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-page {
  width: 100%;
  min-height: 78vh;
  background: #f8fafc;
  box-sizing: border-box;
}

.messages-page-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.messages-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.messages-notification-button {
  width: 38px !important;
  height: 36px !important;
  border-radius: 12px !important;
  border: 1px solid #e5e7eb !important;
  background: #ffffff !important;
}

.messages-counter-banner {
  width: 75%;
  min-height: 56px;
  margin-bottom: 20px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border: 1px solid #ffb8b8;
  border-radius: 14px;
  background: #fff5f5;
  align-items: center;
}

.messages-counter-content {
  display: flex;
  align-items: center;
  gap: 12px;

  min-width: 0;
}

.messages-counter-content > .anticon {
  color: #d2042d;
  font-size: 15px;
}

.messages-counter-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.messages-counter-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.messages-view-thread-button {
  height: 30px !important;
  padding: 0 12px !important;
  border-radius: 10px !important;
  border: 1px solid #d2042d !important;
  background: #ffffff !important;
}

.messages-counter-actions > .anticon {
  color: #99a1af;
  cursor: pointer;
}

.messages-main-card {
  width: 75%;
  height: 69vh;
  margin: 0 auto;
  padding: 0 !important;
  display: flex;
  overflow: hidden;
  margin-top: 15px;
}
.middle-chat-container {
  border-radius: 0px !important;
  border-width: 0px !important;
  width: 45%;
}
.middle-chat-container-width {
  width: 50%;
}
.messages-conversation-list {
  width: 25%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
}
.messages-conversation-list-width {
  width: 50%;
}

.messages-search-wrapper {
  padding: 14px;
}

.messages-search-input {
  height: 36px !important;
  border-radius: 10px !important;
  border-color: #e5e7eb !important;
  margin-top: 10px;
}
.messages-list-scroll {
  flex: 1 1;
  overflow-y: auto;
}

.messages-conversation-item {
  position: relative;

  min-height: 92px;
  padding: 13px 14px;

  display: flex;
  align-items: flex-start;
  gap: 10px;

  border-bottom: 1px solid #f0f1f3;

  cursor: pointer;
  transition: background 0.15s ease;
}

.messages-conversation-item:hover {
  background: #fff8f9;
}

.messages-conversation-item-active {
  background: #fafafa;
  border-left: 2px solid #d2042d;
}
.messages-conversation-content {
  min-width: 0;
  flex: 1 1;
}

.messages-conversation-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.messages-conversation-title-row .common-sub-header-black-14 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.messages-status-row {
  margin-top: 5px;
}

.messages-counter-tag {
  display: inline-flex;
  align-items: center;

  min-height: 21px;
  padding: 3px 9px;

  border-radius: 999px;

  background: #fff1f2;
  color: #d2042d;

  font-family: Roboto;
  font-size: 11px;
  font-weight: 600;
}

.messages-unread-badge {
  position: absolute;
  right: 12px;
  top: 40px;
}

.messages-thread-help {
  padding: 14px;

  border-top: 1px solid #e5e7eb;
}
.location-grey-text-12::marker {
  color: #d2042d !important;
}
.messages-thread-help ul {
  margin: 6px 0 0;
  padding-left: 16px;

  color: #d2042d;
}

.messages-thread-help li {
  margin-bottom: 4px;

  font-family: Roboto;
  font-size: 11px;
}

.messages-chat-panel {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.messages-chat-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.messages-chat-product {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.messages-chat-product-icon {
  width: 34px;
  height: 34px;
  min-width: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #f3f4f6;
  color: #98a2b3;

  border-radius: 9px;
}

.messages-chat-title {
  display: flex;
  align-items: baseline;
  gap: 7px;
  justify-content: space-between;
}
.truncates-65 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 65%;
  display: inline-block;
}
.messages-chat-title .common-product-detail-text-grey-10 {
  text-transform: none !important;
}

.messages-chat-actions {
  display: flex;
  align-items: center;
  gap: 18px;

  color: #98a2b3;
}

.messages-chat-actions .anticon {
  cursor: pointer;
}
.messages-product-summary {
  min-height: 32px;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  gap: 18px;
  border-bottom: 1px solid #f0f1f3;
}

.messages-bottom-chat-input {
  padding: 12px 16px;
}
.messages-chat-body {
  padding: 18px 16px;
  max-height: 47vh;
  overflow-y: auto;
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #98a2b3 #f3f4f6;
}

.messages-chat-body::-webkit-scrollbar {
  width: 10px;
}

.messages-chat-body::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 10px;
}

.messages-chat-body::-webkit-scrollbar-thumb {
  background: #98a2b3;
  border-radius: 10px;
}

.messages-chat-body::-webkit-scrollbar-thumb:hover {
  background: #667085;
}

.messages-chat-row {
  max-width: 70%;
  margin-bottom: 18px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.messages-chat-row-buyer {
  margin-left: auto;
  align-items: flex-end;
}

.messages-chat-bubble {
  padding: 10px 14px;

  border-radius: 14px;

  line-height: 18px;
}

.messages-chat-bubble-seller {
  background: #f3f4f6;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 4px;
}

.messages-chat-bubble-buyer {
  background: #d2042d;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 16px;
}

.messages-chat-row > .grey-color-text-99a1af-11 {
  margin-top: 3px;
}
.common-width-style {
  width: auto !important;
}

.messages-offer-wrapper {
  display: flex;
  justify-content: flex-end;

  margin-top: 10px;
}

.messages-offer-card {
  width: min(310px, 75%);
  padding: 14px;

  border: 1px solid #f4d35e;
  border-radius: 14px;

  background: #fffdf0;
}

.messages-offer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.messages-offer-title {
  display: flex;
  align-items: center;
  gap: 6px;
}

.messages-offer-title .anticon {
  color: #92400e;
}

.messages-offer-payment {
  margin-top: 4px;
}

.messages-offer-card .common-divider-horizontal {
  margin: 10px 0 !important;
  background-color: #f4d35e;
}

.messages-bottom-actions {
  padding: 12px 0px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #e5e7eb;
  padding: 15px;
}

.messages-mobile-composer {
  display: none;
}
.messages-search-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.messages-empty-chat {
  display: flex;
  justify-content: center;
  align-items: center;
}
.messages-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  min-height: 400px;
  padding: 24px;
  color: #64748b;
}

.messages-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: #f1f5f9;
  font-size: 26px;
}

.messages-empty-title {
  display: block;
  margin-bottom: 8px;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.messages-empty-description {
  display: block;
  max-width: 320px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.6;
}
.profile-section-terms {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
@media (max-width: 1024px) {
  .messages-page {
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .messages-page {
    padding: 16px 12px 20px;
  }

  .messages-page-header {
    align-items: flex-start;
  }

  .messages-counter-banner {
    align-items: flex-start;
    gap: 10px;
  }

  .messages-counter-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .messages-conversation-list {
    max-height: 270px;

    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .messages-thread-help {
    display: none;
  }

  .messages-chat-panel {
    min-height: 520px;
  }

  .messages-chat-actions {
    gap: 10px;
  }

  .messages-chat-row {
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  .messages-page-header {
    flex-direction: column;
  }

  .messages-header-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .messages-counter-content {
    align-items: flex-start;
  }

  .messages-counter-banner {
    padding: 12px;
  }

  .messages-chat-title .common-product-detail-text-grey-10 {
    display: none;
  }

  .messages-chat-actions {
    display: none;
  }

  .messages-product-summary {
    flex-wrap: wrap;
    gap: 8px;
  }

  .messages-chat-body {
    padding: 14px 10px;
  }

  .messages-bottom-actions {
    padding: 10px;
  }

  .messages-offer-card {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/messages/Messages.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,gCAAgC;;EAEhC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,gBAAgB;EAChB,gBAAgB;;EAEhB,oBAAoB;;EAEpB,mBAAmB;EACnB,cAAc;;EAEd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;;EAEzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;;IAEjB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".messages-page {\n  width: 100%;\n  min-height: 78vh;\n  background: #f8fafc;\n  box-sizing: border-box;\n}\n\n.messages-page-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.messages-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.messages-notification-button {\n  width: 38px !important;\n  height: 36px !important;\n  border-radius: 12px !important;\n  border: 1px solid #e5e7eb !important;\n  background: #ffffff !important;\n}\n\n.messages-counter-banner {\n  width: 75%;\n  min-height: 56px;\n  margin-bottom: 20px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  border: 1px solid #ffb8b8;\n  border-radius: 14px;\n  background: #fff5f5;\n  align-items: center;\n}\n\n.messages-counter-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  min-width: 0;\n}\n\n.messages-counter-content > .anticon {\n  color: #d2042d;\n  font-size: 15px;\n}\n\n.messages-counter-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.messages-counter-actions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.messages-view-thread-button {\n  height: 30px !important;\n  padding: 0 12px !important;\n  border-radius: 10px !important;\n  border: 1px solid #d2042d !important;\n  background: #ffffff !important;\n}\n\n.messages-counter-actions > .anticon {\n  color: #99a1af;\n  cursor: pointer;\n}\n\n.messages-main-card {\n  width: 75%;\n  height: 69vh;\n  margin: 0 auto;\n  padding: 0 !important;\n  display: flex;\n  overflow: hidden;\n  margin-top: 15px;\n}\n.middle-chat-container {\n  border-radius: 0px !important;\n  border-width: 0px !important;\n  width: 45%;\n}\n.middle-chat-container-width {\n  width: 50%;\n}\n.messages-conversation-list {\n  width: 25%;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e5e7eb;\n}\n.messages-conversation-list-width {\n  width: 50%;\n}\n\n.messages-search-wrapper {\n  padding: 14px;\n}\n\n.messages-search-input {\n  height: 36px !important;\n  border-radius: 10px !important;\n  border-color: #e5e7eb !important;\n  margin-top: 10px;\n}\n.messages-list-scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.messages-conversation-item {\n  position: relative;\n\n  min-height: 92px;\n  padding: 13px 14px;\n\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n\n  border-bottom: 1px solid #f0f1f3;\n\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.messages-conversation-item:hover {\n  background: #fff8f9;\n}\n\n.messages-conversation-item-active {\n  background: #fafafa;\n  border-left: 2px solid #d2042d;\n}\n.messages-conversation-content {\n  min-width: 0;\n  flex: 1;\n}\n\n.messages-conversation-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.messages-conversation-title-row .common-sub-header-black-14 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.messages-status-row {\n  margin-top: 5px;\n}\n\n.messages-counter-tag {\n  display: inline-flex;\n  align-items: center;\n\n  min-height: 21px;\n  padding: 3px 9px;\n\n  border-radius: 999px;\n\n  background: #fff1f2;\n  color: #d2042d;\n\n  font-family: Roboto;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.messages-unread-badge {\n  position: absolute;\n  right: 12px;\n  top: 40px;\n}\n\n.messages-thread-help {\n  padding: 14px;\n\n  border-top: 1px solid #e5e7eb;\n}\n.location-grey-text-12::marker {\n  color: #d2042d !important;\n}\n.messages-thread-help ul {\n  margin: 6px 0 0;\n  padding-left: 16px;\n\n  color: #d2042d;\n}\n\n.messages-thread-help li {\n  margin-bottom: 4px;\n\n  font-family: Roboto;\n  font-size: 11px;\n}\n\n.messages-chat-panel {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.messages-chat-header {\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.messages-chat-product {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.messages-chat-product-icon {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #f3f4f6;\n  color: #98a2b3;\n\n  border-radius: 9px;\n}\n\n.messages-chat-title {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  justify-content: space-between;\n}\n.truncates-65 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 65%;\n  display: inline-block;\n}\n.messages-chat-title .common-product-detail-text-grey-10 {\n  text-transform: none !important;\n}\n\n.messages-chat-actions {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n\n  color: #98a2b3;\n}\n\n.messages-chat-actions .anticon {\n  cursor: pointer;\n}\n.messages-product-summary {\n  min-height: 32px;\n  padding: 7px 20px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  border-bottom: 1px solid #f0f1f3;\n}\n\n.messages-bottom-chat-input {\n  padding: 12px 16px;\n}\n.messages-chat-body {\n  padding: 18px 16px;\n  max-height: 47vh;\n  overflow-y: auto;\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #98a2b3 #f3f4f6;\n}\n\n.messages-chat-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.messages-chat-body::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 10px;\n}\n\n.messages-chat-body::-webkit-scrollbar-thumb {\n  background: #98a2b3;\n  border-radius: 10px;\n}\n\n.messages-chat-body::-webkit-scrollbar-thumb:hover {\n  background: #667085;\n}\n\n.messages-chat-row {\n  max-width: 70%;\n  margin-bottom: 18px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.messages-chat-row-buyer {\n  margin-left: auto;\n  align-items: flex-end;\n}\n\n.messages-chat-bubble {\n  padding: 10px 14px;\n\n  border-radius: 14px;\n\n  line-height: 18px;\n}\n\n.messages-chat-bubble-seller {\n  background: #f3f4f6;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 16px;\n  border-bottom-left-radius: 4px;\n}\n\n.messages-chat-bubble-buyer {\n  background: #d2042d;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 16px;\n}\n\n.messages-chat-row > .grey-color-text-99a1af-11 {\n  margin-top: 3px;\n}\n.common-width-style {\n  width: auto !important;\n}\n\n.messages-offer-wrapper {\n  display: flex;\n  justify-content: flex-end;\n\n  margin-top: 10px;\n}\n\n.messages-offer-card {\n  width: min(310px, 75%);\n  padding: 14px;\n\n  border: 1px solid #f4d35e;\n  border-radius: 14px;\n\n  background: #fffdf0;\n}\n\n.messages-offer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.messages-offer-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.messages-offer-title .anticon {\n  color: #92400e;\n}\n\n.messages-offer-payment {\n  margin-top: 4px;\n}\n\n.messages-offer-card .common-divider-horizontal {\n  margin: 10px 0 !important;\n  background-color: #f4d35e;\n}\n\n.messages-bottom-actions {\n  padding: 12px 0px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-top: 1px solid #e5e7eb;\n  padding: 15px;\n}\n\n.messages-mobile-composer {\n  display: none;\n}\n.messages-search-empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.messages-empty-chat {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.messages-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  height: 100%;\n  min-height: 400px;\n  padding: 24px;\n  color: #64748b;\n}\n\n.messages-empty-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 16px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  font-size: 26px;\n}\n\n.messages-empty-title {\n  display: block;\n  margin-bottom: 8px;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.messages-empty-description {\n  display: block;\n  max-width: 320px;\n  color: #94a3b8;\n  font-size: 13px;\n  line-height: 1.6;\n}\n.profile-section-terms {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n@media (max-width: 1024px) {\n  .messages-page {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .messages-page {\n    padding: 16px 12px 20px;\n  }\n\n  .messages-page-header {\n    align-items: flex-start;\n  }\n\n  .messages-counter-banner {\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .messages-counter-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .messages-conversation-list {\n    max-height: 270px;\n\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .messages-thread-help {\n    display: none;\n  }\n\n  .messages-chat-panel {\n    min-height: 520px;\n  }\n\n  .messages-chat-actions {\n    gap: 10px;\n  }\n\n  .messages-chat-row {\n    max-width: 85%;\n  }\n}\n\n@media (max-width: 480px) {\n  .messages-page-header {\n    flex-direction: column;\n  }\n\n  .messages-header-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .messages-counter-content {\n    align-items: flex-start;\n  }\n\n  .messages-counter-banner {\n    padding: 12px;\n  }\n\n  .messages-chat-title .common-product-detail-text-grey-10 {\n    display: none;\n  }\n\n  .messages-chat-actions {\n    display: none;\n  }\n\n  .messages-product-summary {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .messages-chat-body {\n    padding: 14px 10px;\n  }\n\n  .messages-bottom-actions {\n    padding: 10px;\n  }\n\n  .messages-offer-card {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
